import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconMiniChevronRight(props: SvgIconProps) {
  return (
    <SVGIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3.5 1L8.5 6L3.5 11" stroke="currentColor" strokeWidth="1.5" />
    </SVGIcon>
  );
}
